import React, { useState, useContext } from "react"; // 1. Add useContext
import { Link } from "react-router-dom";
import "../../Authentication/AuthModal.css";
import LoginModal from "../../Authentication/LoginModal";
import RegisterModal from "../../Authentication/RegisterModal";
import { useAuth } from "../../Common/Configurations/AuthContext"; // 1. Import useAuth
import { LandingContext } from "../../Components/Profile/LandingContext";
import DefaultData from "../../CompanyData/DefaultData";
import ForgotPasswordModal from "../../Authentication/ForgotPasswordModal";

export default function PublicHeader(props) {
  const { user } = useAuth(); // 2. Get user object from context
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const landingData = useContext(LandingContext);

  const handleCloseModals = () => {
    setShowLoginModal(false);
    setShowRegisterModal(false);
    setShowForgotPasswordModal(false);
  };

  const handleShowLogin = () => {
    handleCloseModals();
    setShowLoginModal(true);
  };

  const handleSwitchToRegister = () => {
    setShowLoginModal(false);
    setShowRegisterModal(true);
  };
  const handleSwitchToForgotPassword = () => {
        setShowLoginModal(false);
        setShowRegisterModal(false);
        setShowForgotPasswordModal(true);
    };

  const handleSwitchToLogin = () => {
    setShowRegisterModal(false);
    setShowLoginModal(true);
  };
  const primaryButtonStyle = {
    backgroundColor: landingData?.themeColor2 || DefaultData?.THEMECOLOR1,
    borderColor: landingData?.themeColor2 || DefaultData?.THEMECOLOR1,
    color: "#ffffff",
  };

    return (
        <>
            <div className="navbar-header" style={{ backgroundColor: props? DefaultData?.THEMECOLOR3 : props.value?.themeColor3, padding: '0.5rem 1rem' }}>
                <div className="d-flex justify-content-between align-items-center flex-wrap w-100">
                    {/* Your Logo and Menu Links ... */}
                    <div className="d-flex align-items-center gap-4 flex-wrap">
                        <div className="navbar-brand-box horizontal-logo">
                            <Link className="logo fs-3" to={"/"}>
                                        <img src="/assets/images/logo.jpg" alt="Company Logo2" width={"180px"} height={"50px"} />
                            </Link>
                        </div>
                        <div className="d-flex align-items-center ms-5 gap-3" style={{ fontSize: "14px" }}>
                            <Link className="nav-link menu-link me-2" to="/flight/search">
                                <img src="/assets/images/icons/flight.png" width={36} className="me-1" /><span>Flights</span>
                            </Link>
                            <Link className="nav-link menu-link me-2" to="/hotel/search">
                                <img src="/assets/images/icons/hotel.png" width={36} className="me-1" /><span>Hotels</span>
                            </Link>
                            <Link className="nav-link menu-link me-2" to="/holidays">
                                <img src="/assets/images/icons/holidays.png" width={36} className="me-1" /><span>Packages</span>
                            </Link>
                            <Link className="nav-link menu-link me-2" to="/search/sightseeing">
                                <img src="/assets/images/icons/sightseeing.png" width={24} height={24} className="me-1" /><span>SightSeeing</span>
                            </Link>
                        </div>
                    </div>
                    <div className="d-flex align-items-center">
                        {user ? (
                            <Link to="/my-profile" className="btn btn-search2" style={{backgroundColor:DefaultData.THEMECOLOR2, color:DefaultData.THEMECOLOR3}}>
                                <i className="ri-user-line p-1 me-1"></i>MY ACCOUNT
                            </Link>
                        ) : (
                            <Link onClick={handleShowLogin} className="btn btn-search2" style={{backgroundColor:DefaultData.THEMECOLOR1, color:DefaultData.THEMECOLOR3}}>
                                <i className="ri-user-line p-1 me-1"></i>LOGIN
                            </Link>
                        )}
                    </div>
                </div>
              
            </div>
            
          {!user && (
        <>
          <LoginModal
            show={showLoginModal}
            onClose={handleCloseModals}
            onSwitchToRegister={handleSwitchToRegister}
            onSwitchToForgotPassword={handleSwitchToForgotPassword}
          />
          <RegisterModal
            show={showRegisterModal}
            onClose={handleCloseModals}
            onSwitchToLogin={handleSwitchToLogin}
            onLoginSuccess={handleCloseModals}
          />
          <ForgotPasswordModal 
                show={showForgotPasswordModal}
                onClose={handleCloseModals}
                onSwitchToLogin={handleSwitchToLogin}
            />
        </>
      )}
      </>
  );
}
